import { render } from "./Project_recommendation.vue?vue&type=template&id=8ba3fd58&scoped=true&ts=true"
import script from "./Project_recommendation.vue?vue&type=script&lang=ts"
export * from "./Project_recommendation.vue?vue&type=script&lang=ts"

import "./Project_recommendation.vue?vue&type=style&index=0&id=8ba3fd58&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ba3fd58"]])

export default __exports__